@if (rows.length) {
  <div class="heatmap-scroll-x">
    <div class="heatmap" [class.divergent]="divergent">
      <div class="hm-grid" [style.grid-template-columns]="gridTemplate">
        <div class="hm-corner"></div>
        @for (col of colHeaders; track $index; let c = $index) {
          <div
            class="hm-label col"
            [class.dim]="isLabelDimmed('col', c)"
            [matTooltip]="col.full"
            matTooltipClass="heatmap-tip"
          >
            {{ col.label }}
          </div>
        }
        @for (row of rows; track $index; let r = $index) {
          <div
            class="hm-label row"
            [class.dim]="isLabelDimmed('row', r)"
            [matTooltip]="row.full"
            matTooltipClass="heatmap-tip"
          >
            {{ row.label }}
          </div>
          @for (cell of row.cells; track $index; let c = $index) {
            <div
              class="hm-cell"
              [class.diag]="r === c"
              [class.dim]="isCellDimmed(r, c)"
              [class.strong]="cell.strong"
              [style.background]="cell.background"
              (mouseenter)="setHover(r, c)"
              (mouseleave)="clearHover()"
            >
              {{ cell.value }}
            </div>
          }
        }
      </div>
    </div>
  </div>
}
